<mat-card appearance="outlined">
  <mat-card-content>
      <h2>{{'help.maintenance.title.fullLabel' | translate}}</h2>
      <p>
        {{'help.maintenance.underMaintenance.summary' | translate}}
      </p>
  </mat-card-content>
</mat-card>
